import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AccountService } from 'app/account/account.service';
import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { StatusIdEnum } from 'app/_models/statusId';

@Injectable({ providedIn: 'root' })
export class SellerOrderService extends BaseService {
    private _domain: string = '/seller/orders';
    private _domainDashboard: string = '/seller/dashboard';

    constructor(private accountService: AccountService, private config: SettingsService) {
        super();
    }

    public setAsAwaitingForDelivery(order_id: number, new_payment_type_id: number) {
        let url = `${this._domain}/${order_id}/set-as-awaiting-for-delivery`;

        if (new_payment_type_id !== null && new_payment_type_id !== undefined)
            url += `/${new_payment_type_id}`;
        
        return this.config.executePost({ url: url, body: {} });
    }

    public getOrderReasons(status_id: number){
        return this.config.executeGet({ url: `${this._domainDashboard}/reject-order-reasons/${status_id}` });
    }

    public rejectItens(order_id: number, pecas_ids: number[], cancel_reason_id: number, notes: string = null) {
        const body = { pecas_ids, cancel_reason_id, notes };
        return this.config.executePost({ url: `${this._domain}/${order_id}/reject-itens`, body });
    }

    public removeNotaFiscal(order_id: number, path: string): Observable<any> {
        const body = { id: order_id, filename: path };

        return this.config.executeDelete({ url: `${this._domain}/${order_id}/notas-fiscais`, body });
    }

    public setAsAwaitingForPickupReplacement(order_id: number, pecas_ids: number[], data_selecionada: Date, status: StatusIdEnum) {
        const type = status == StatusIdEnum.AguardandoConfirmacaoTroca ? 'replacement' : 'pickup';
        const body = { pecas_ids, data_selecionada };
        return this.config.executePost({ url: `${this._domain}/${order_id}/set-as-awaiting-for-${type}`, body });
    }

    public setAsInAnalysis(order_id: number, cancel_reason_id: number, notes: string) {
        const body = { cancel_reason_id, notes };

        return this.config.executePost({ url: `${this._domain}/${order_id}/set-as-in-analysis`, body });
    }

    public uploadNotaFiscal(order_id: number, b64file: any, filename: string): Observable<any> {
        var formData = new FormData();
        formData.append("id", order_id.toString());
        formData.append("b64file", b64file);
        formData.append("filename", filename);

        return this.config.executePost({ url: `${this._domain}/${order_id}/notas-fiscais`, body: formData, isJson: false });
    }
}
